require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-avoiding-risky-business-how-can-idb-group-make-its.json") })
        }
      }, "path---en-us-update-avoiding-risky-business-how-can-idb-group-make-its");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-avoiding-risky-business-how-can-idb-group-make-its!./.cache/json/en-us-update-avoiding-risky-business-how-can-idb-group-make-its.json
// module id = 616
// module chunks = 231608221292675